var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_502_105409)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.2982,
    cy: 23.0198,
    r: 16.2357,
    fill: "url(#paint0_linear_502_105409)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.2982,
    cy: 23.0198,
    r: 16.2357,
    fill: "url(#paint1_radial_502_105409)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_502_105409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8178 29.9443V28.0332L19.5659 24.1181C20.3081 23.3387 20.8772 22.7202 21.273 22.2625C21.6812 21.7925 21.9657 21.3905 22.1265 21.0565C22.2873 20.7225 22.3678 20.3823 22.3678 20.0359C22.3678 19.4545 22.1822 18.9969 21.8111 18.6629C21.4524 18.3289 20.9885 18.1619 20.4195 18.1619C19.8257 18.1619 19.3124 18.3351 18.8794 18.6814C18.4465 19.0154 18.131 19.5102 17.9331 20.1658L15.725 19.4793C15.8735 18.7495 16.1766 18.1186 16.6342 17.5867C17.0919 17.0424 17.6486 16.628 18.3042 16.3435C18.9722 16.0466 19.6773 15.8982 20.4195 15.8982C21.3101 15.8982 22.0894 16.059 22.7574 16.3806C23.4378 16.7022 23.9635 17.1537 24.3346 17.7351C24.7181 18.3165 24.9098 18.9969 24.9098 19.7762C24.9098 20.271 24.817 20.7596 24.6315 21.242C24.4459 21.7245 24.1676 22.2193 23.7965 22.7264C23.4254 23.2212 22.943 23.7779 22.3492 24.3964L19.1021 27.8105H25.0953V29.9443H15.8178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_502_105409",
    x: -27.945,
    y: -25.2233,
    width: 96.4856,
    height: 96.4861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.0037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_105409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_105409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_502_105409",
    x: 0.648634,
    y: 0.821974,
    width: 39.523,
    height: 44.1983,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.53799
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_105409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_105409",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_105409",
    x1: -8.7387,
    y1: 44.5633,
    x2: 67.7563,
    y2: -1.64587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#73C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B46A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_502_105409",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.045 77.7259) rotate(-145.948) scale(221.518 74.2714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop2);
export default __webpack_public_path__ + "static/media/Top2.7b965fb6b9e2ee9d2cca34abd77ad20f.svg";
export { ForwardRef as ReactComponent };